module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowledgments",
    attrs: {
      "id": "ack"
    }
  }, [_c('h1', {
    staticClass: "chapter1"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Special thanks to: Bob Gleason and Eric Raab for guidance on a number of issues; Meg Ruley for her sharp insight and unending support; Justin Golenbock for his efforts to publicize my novels; Matthew Kuhn for his help in explaining the mysteries of websites; Florida statewide prosecutor William Shepard for his incredible support through all my novels; and Buch Buchanan for outstanding editing and proofreading skills.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef16420","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781429949323_epub_ack_r1.vue
// module id = 75
// module chunks = 0